import { API_BASE, fetchJson } from './client';

export const photo = {
  readExif: (filePath: string) =>
    fetchJson('/photos/exif', { method: 'POST', body: JSON.stringify({ filePath }) }),
  generateThumbnail: (filePath: string, size?: number) =>
    fetchJson('/photos/thumbnail', { method: 'POST', body: JSON.stringify({ filePath, size }) }),
  getDataUrl: (filePath: string) =>
    fetchJson<{ dataUrl: string }>('/photos/data-url', { method: 'POST', body: JSON.stringify({ filePath }) })
      .then(r => r.dataUrl),
  serveUrl: (filePath: string) => {
    if (filePath.startsWith('/api/')) return filePath;
    return `${API_BASE}/photos/serve?path=${encodeURIComponent(filePath)}`;
  },
  detectPhotos: (projectId: string) =>
    fetchJson<{
      found: boolean;
      s3Count: number;
      registeredCount: number;
      placedCount: number;
      unplacedCount: number;
      sources?: Record<string, number>;
    }>(`/photos/detect/${projectId}`, { method: 'POST' }),
  registerPhotos: (projectId: string) =>
    fetchJson<{
      imported: number;
      skipped: number;
      gpsFound: number;
      gpsNotFound: number;
      total: number;
    }>(`/photos/register/${projectId}`, { method: 'POST' }),
};
